import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel } from '@mui/material';
import { PdfActionButtons } from '../../../../../components/pdf-actions/pdf-action-buttons';

interface IAttendanceProtocolPdfDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (includeCpr: boolean) => void;
  pdfActions?: {
    onOpen: (includeCpr: boolean) => void;
    onDownload: (includeCpr: boolean) => void;
  };
}

export function AttendanceProtocolPdfDialog(props: IAttendanceProtocolPdfDialogProps) {
  const { open, onClose, onConfirm, pdfActions } = props;

  const [includeCpr, setIncludeCpr] = useState(false);

  useEffect(() => {
    if (open) {
      setIncludeCpr(false);
    }
  }, [open]);

  function handleConfirm() {
    onConfirm(includeCpr);
    onClose();
  }

  function runAndClose(action: (includeCpr: boolean) => void) {
    return () => {
      action(includeCpr);
      onClose();
    };
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Dan protokol som PDF</DialogTitle>
      <DialogContent>
        <FormControlLabel
          control={<Checkbox checked={includeCpr} onChange={event => setIncludeCpr(event.target.checked)} />}
          label="Vis CPR-numre på protokollen"
        />
      </DialogContent>
      <DialogActions>
        {pdfActions ? (
          <PdfActionButtons variant="contained" onOpen={runAndClose(pdfActions.onOpen)} onDownload={runAndClose(pdfActions.onDownload)} />
        ) : (
          <Button variant="contained" onClick={handleConfirm}>
            Dan PDF
          </Button>
        )}
        <Button variant="outlined" onClick={onClose}>
          Afbryd
        </Button>
      </DialogActions>
    </Dialog>
  );
}
